import React, { MouseEvent } from 'react'
import { Button } from "@mui/material";

interface Props {
    text: string
    color: string | undefined
    onClick: (e?: MouseEvent<HTMLButtonElement>) => void
    disabled: boolean
}

const FullWidthMobileButton:React.FC<Props> = ({text, color, onClick, disabled }) => {
    return (
        <Button
            variant="contained"
            color={color}
            style={{
                width: "100%",
                padding: "6px 0",
                fontSize: "22px"
            }}
            onClick={(e: MouseEvent<HTMLButtonElement>):void => onClick(e)}
            disabled={disabled}
        >
            {text}
        </Button>)
}
export default FullWidthMobileButton